// TODO: remove when cleaning up remove-jira-settings-iviq
export const getJiraSettingsQuery = () => `
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;
